/**
 * @name 步骤条
 */
import base from '../../base';
import Steps from './steps';

Steps.install = function(Vue) {
  Vue.use(base);
  Vue.component(Steps.name, Steps);
};

export default Steps;
